import PropTypes from "prop-types";
import kebabCase from "lodash.kebabcase";
import React, { Component } from "react";
import getClassNameFactory from "@emcm-ui/utility-class-names";
import Menu from "./components/Menu";
import Item from "./components/Item";
import { Provider as VerticalNavProvider } from "./verticalNavContext";
import getRehydratableName from "@emcm-ui/utility-rehydratable-name";
import { AjaxContentContext } from "@emcm-ui/component-ajax-content";
import classNames from "classnames";
import { SVGIcon } from "@emcm-ui/component-icon/lib/svg";

class VerticalNav extends Component {
  static displayName = "VerticalNav";

  static propTypes = {
    /**
     * children for Verical Navigation
     */
    children: PropTypes.node,
    /**
     * To know whether rehydration happens or not. Don't use it
     */
    isRehydrating: PropTypes.bool
  };

  static getLocationHash = () => {
    if (window && window.location && window.location.hash) {
      return window.location.hash.substr(1);
    }

    return null;
  };

  static setLocationHash = hash => {
    if (window && window.location) {
      window.location.hash = hash;
    }
  };

  state = {
    selectedItem: "",
    expanded: false
  };

  handleClick = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  updateFromHash() {
    const locationHash = VerticalNav.getLocationHash();
    const queryElement = document.querySelector(`[data-id=${locationHash}]`);

    if (locationHash && queryElement) {
      queryElement.click();
    }
  }
  componentDidMount() {
    this.updateFromHash();
    if (window) {
      window.addEventListener("hashchange", this.updateFromHash);
    }
  }

  onItemClick = ({
    label,
    href,
    ajaxContext,
    event = false,
    isAjax,
    isUrlHashActive
  }) => {
    if (ajaxContext && isAjax) {
      if (event) event.preventDefault();
      ajaxContext.updateHref(href);
      if (isUrlHashActive) {
        VerticalNav.setLocationHash(`#${kebabCase(label)}`);
      }
    }
    this.setState({ selectedItem: label, expanded: false });
  };

  render() {
    const { children } = this.props;
    const { selectedItem, expanded } = this.state;
    const getClassName = getClassNameFactory(VerticalNav.displayName);
    const contextValue = {
      selectedItem,
      onItemClick: this.onItemClick
    };

    return (
      <AjaxContentContext.Consumer>
        {ajaxContext => {
          return (
            <VerticalNavProvider value={contextValue}>
              <div
                className={getClassName({ states: classNames({ expanded }) })}
                data-rehydratable={getRehydratableName(VerticalNav.displayName)}
              >
                <button
                  className={getClassName({
                    descendantName: "currentItem"
                  })}
                  onClick={this.handleClick}
                >
                  <span
                    className={getClassName({
                      descendantName: "currentItemIcon"
                    })}
                  >
                    <SVGIcon name="menu" size="s" />
                  </span>
                  <span
                    className={getClassName({
                      descendantName: "currentItemTitle"
                    })}
                  >
                    {selectedItem}
                  </span>
                </button>

                <div className={getClassName({ descendantName: "children" })}>
                  {children &&
                    children.props && (
                      <children.type
                        indent={0}
                        {...children.props}
                        key={children.props.label}
                        ajaxContext={ajaxContext}
                      />
                    )}

                  {children &&
                    children.length > 0 &&
                    children.map(element => {
                      if (element) {
                        const Element = element.type;

                        return (
                          <Element
                            indent={0}
                            {...element.props}
                            key={element.props.label}
                            ajaxContext={ajaxContext}
                          />
                        );
                      }

                      return false;
                    })}
                </div>
              </div>
            </VerticalNavProvider>
          );
        }}
      </AjaxContentContext.Consumer>
    );
  }
}

VerticalNav.Menu = Menu;
VerticalNav.Item = Item;
export default VerticalNav;
